export default __webpack_public_path__ + "static/media/Xinney.e5fe18b7.png";